import React, { useEffect, useState } from "react";
import { Button } from "../../components/Button/Button";
import Logo from "../../assets/images/akra_logo.png";
import { GetResetPassword } from "../../api/api";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export const ResetPassword = () => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [createPassword, setCreatePassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [response, setResponse] = useState<any>(null);
  const [newResponse, setNewResponse] = useState<any>("");
  const [responseState, setResponseState] = useState(false);

  let email = new URLSearchParams(useLocation().search).get("email");
  let getToken:any = new URLSearchParams(useLocation().search).get("token");
  const token = encodeURIComponent(getToken);
  const navigate = useNavigate();

  function handleCreatePassword(e: any) {
    setCreatePassword(e.target.value);
  }

  function handleConfirmPassword(e: any) {
    setConfirmPassword(e.target.value);
  }
  const showMessageWithDelay = () => {
    // Set the state to true after 2 seconds (2000 milliseconds)
    setTimeout(() => {
      const successMessage = 'Password Created Successfully, Please login here';
      Cookies.set('resetPasswordMsg', successMessage, {
        expires: 7,
        path: "/",
      });
    // Navigate to the login page
    navigate('/');
    }, 2000);
  };

  function handlebtnClick() {
    setIsBtnLoading(true);
    GetResetPassword(email, createPassword, confirmPassword, token)
      .then((response) => response.json())

      .then((response) => {
        setResponse(response?.errors?.[0]?.message ?? "");
        setResponseState(true);
        setIsBtnLoading(false);
      })
      .catch((error) => {
        setNewResponse(error);
        console.log("error: " + error);
        setIsBtnLoading(false);
        setResponse('Password Created Successfully')
        showMessageWithDelay()
      });
  }

  return (
    <main className="main h-100 w-100">
      <div className="container h-100">
        <div className="row h-100 mt-4">
          <div className="col-sm-10 col-md-8 col-lg-5 mx-auto d-table h-100 mt-4">
            <div className="d-table-cell align-middle mt-4">
              <div className="text-center mt-4">
                <h1 className="h2">Reset Your Password</h1>
                <p className="lead">Create Your New Password</p>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="m-sm-4">
                    <div className="text-center">
                      <img
                        src={Logo}
                        alt="Linda Miller"
                        className="img-fluid"
                        width="100"
                        height="100"
                      />
                    </div>

                    <div className="my-3">
                      <label htmlFor="email" className="text-body">
                        Create Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) => handleCreatePassword(e)}
                      />
                    </div>
                    <div className="my-3">
                      <label htmlFor="email" className="text-body">
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) => handleConfirmPassword(e)}
                      />
                    </div>
                    {createPassword !== confirmPassword ? (
                      <div className="text-danger">Passwords not match</div>
                    ) : null}
                    <div>
                      {responseState !== true ? (
                        <div className="text-success">
                          {response}
                        </div>
                      ) : (
                        <div className="text-danger">{response}</div>
                      )}
                    </div>
                    

                    <div className="text-center mt-3">
                    <Button
                        type="submit"
                        className="btn-link"
                        size="btn-lg"
                        children="Cancel"
                        //showLoading={isBtnLoading}
                        onClick={() => navigate('/')}
                      />
                      <Button
                        type="submit"
                        className="btn-primary"
                        size="btn-lg"
                        children="Submit"
                        showLoading={isBtnLoading}
                        onClick={handlebtnClick}
                      />
                    

                      {/* <!-- <button type="submit" className="btn btn-lg btn-primary">Sign in</button> --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
